import { Categories } from '../Categories';
class CountryEndpoint extends Categories {
    constructor() {
        super("/Country");
    }
}
export default new CountryEndpoint();